const state = {
    materials: []
}

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
}

const actions = {
    async fetch({commit}) {
        const response = await this.$api.materials.fetch(); 
         
        commit('setState', {
            key: 'materials',
            value: response.data.data || []
        });
    }
}

const getters = {
    materials: state => state.materials
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
}